// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"135":"a6b1ac60","309":"2770b325","428":"4ea6c856","555":"801e03b1","578":"1ab4cd62","586":"677bf9a4"}[chunkId] + ".js";
};